"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPreviewUrls = exports.unsetPreviewFlashCompleted = exports.setPreviewFlashCompleted = exports.setPreviewError = exports.setPreviewId = exports.unsetPreviewQueued = exports.setPreviewQueued = exports.startPreviewRequest = exports.determinePreviewState = exports.PREVIEW_STATES = undefined;

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _omit = require("lodash/omit");

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREVIEW_STATES = exports.PREVIEW_STATES = {
  PREVIEW_REQUESTABLE: "PREVIEW_REQUESTABLE",
  PREVIEW_REQUESTING: "PREVIEW_REQUESTING", // requesting preview model from picasso
  PREVIEW_QUEUED: "PREVIEW_QUEUED", // got preview model from picasso, but job hasn't started processing yet
  PREVIEW_ERROR: "PREVIEW_ERROR", // Error occurred from Picasso
  PREVIEW_LOADING: "PREVIEW_LOADING", // Have a preview id, but waiting for Picasso to proccess the preview job
  PREVIEW_FLASH_COMPLETED: "PREVIEW_FLASH_COMPLETED", // state for when we retrieve that the preview is finished for the first time (mainly used to flash completed feedback to user)
  PREVIEW_AVAILABLE: "PREVIEW_AVAILABLE" // preview image urls are available to be viewed
};

var determinePreviewState = exports.determinePreviewState = function determinePreviewState() {
  var previewObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!previewObj) return PREVIEW_STATES.PREVIEW_REQUESTABLE;

  if (previewObj.error) return PREVIEW_STATES.PREVIEW_ERROR;else if (previewObj.previewQueued) return PREVIEW_STATES.PREVIEW_QUEUED;else if (previewObj.requestingPreview) return PREVIEW_STATES.PREVIEW_REQUESTING;else if (previewObj.flashCompleted) return PREVIEW_STATES.PREVIEW_FLASH_COMPLETED;else if (previewObj.previewUrls) return PREVIEW_STATES.PREVIEW_AVAILABLE;

  return PREVIEW_STATES.PREVIEW_LOADING;
};

// These function help update the `preview` object on each dataSource variation row
var startPreviewRequest = exports.startPreviewRequest = function startPreviewRequest() {
  return {
    requestingPreview: true
  };
};

var setPreviewQueued = exports.setPreviewQueued = function setPreviewQueued(previewObj, previewId) {
  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'setPreviewQueued'"
    });
  }

  return (0, _assign2.default)({}, previewObj, { previewQueued: true });
};

var unsetPreviewQueued = exports.unsetPreviewQueued = function unsetPreviewQueued(previewObj, previewId) {
  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'unsetPreviewQueued'"
    });
  }

  return (0, _omit2.default)(previewObj, ["previewQueued"]);
};

var setPreviewId = exports.setPreviewId = function setPreviewId(previewObj, previewId) {
  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'setPreviewId'"
    });
  }

  return (0, _assign2.default)({}, previewObj, { id: previewId, requestingPreview: false });
};

var setPreviewError = exports.setPreviewError = function setPreviewError(previewObj, error) {
  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'setPreviewError'"
    });
  }

  return (0, _assign2.default)({}, previewObj, { error: error, requestingPreview: false });
};

var setPreviewFlashCompleted = exports.setPreviewFlashCompleted = function setPreviewFlashCompleted(previewObj) {
  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'setPreviewFlashCompleted'"
    });
  }

  return (0, _assign2.default)({}, previewObj, { flashCompleted: true });
};

var unsetPreviewFlashCompleted = exports.unsetPreviewFlashCompleted = function unsetPreviewFlashCompleted(previewObj) {
  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'unsetPreviewFlashCompleted'"
    });
  }

  return (0, _omit2.default)(previewObj, ["flashCompleted"]);
};

var setPreviewUrls = exports.setPreviewUrls = function setPreviewUrls(previewObj) {
  var urls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!previewObj) {
    throw (0, _assign2.default)({
      title: "Error",
      message: "previewObj must be passed to function 'setPreviewUrls'"
    });
  }

  return (0, _assign2.default)({}, previewObj, { previewUrls: urls });
};


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/helpers/picasso/index.js
// module id = 3888
// module chunks = 5 6 7 8